import React from "react";


// @material-ui/icons
import { CircularProgress } from '@mui/material';

// core components
import { useState } from 'react';
import { useQuery, useMutation } from "react-query";
import axios from "axios";
import { Box, Typography, ListItem, makeStyles } from '@mui/material';
import CertIcon from '@mui/icons-material/Badge';
import { Card } from '@mui/material';
import { CardActions } from '@mui/material';
import { CardContent } from '@mui/material';
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import { DialogTitle } from '@mui/material';
import { Dialog } from '@mui/material';
import { DialogContent } from '@mui/material';
import { DialogContentText } from '@mui/material';
import { DialogActions } from '@mui/material';
import { Alert } from '@mui/material';
import { queryClient } from 'index.js';
import { useToken } from "hooks/token.js";
import { useAxiosAuth } from "hooks/axios.js";
import Button from "components/CustomButtons/Button.js";
import { getApiCall } from "hooks/axios";

export default function CertInfoTable(props) {
  const url = "/api/v1/k8s/certificates";
  const clusterCertUpdateUrl = url + '/cluster';
  const CertName = () => (
    <CertIcon fontSize="large" />
  );

  const [token, setToken] = useToken();
  useAxiosAuth(token);

  const [anchorElCluster, setAnchorElCluster] = React.useState(null);
  const [anchorElIngress, setAnchorElIngress] = React.useState(null);
  const openClusterPop = Boolean(anchorElCluster);
  const openIngressPop = Boolean(anchorElIngress);
  const ingressPopId = openIngressPop ? 'ingress-cert-popover' : undefined;
  const columns = [
    { Header: "", accessor: "icon", width: "1px" },
    { Header: "Name", accessor: "name", width: "45%", align: "left" },
    { Header: "Issuer", accessor: "issuer", align: "left" },
    { Header: "Expiry", accessor: "expiry", align: "center" }
  ];

  const mutationCluster = useMutation(() => {
    return axios.post(clusterCertUpdateUrl);
  },
    {
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries('certificate');
      }
    }
  )

  const { isLoading, error, data } = useQuery(
    "certificate",
    async () => await getApiCall(url, {
      onError: function(error) {
        /// we should handle error here
      }
    }), 
    {
      refetchInterval: 10000,
      retryDelay: 3000,
      retry: true
    }
  )

  const certData = (data) => {
    let tableData = {
      columns: columns,
      rows: []
    };
    if (data && data.hasOwnProperty('items') && data.items.length > 0) {
        tableData.rows = data.items.map((item) => {
          return {
            icon: <CertName />,
            name: (item.common_name) ? item.common_name : "",
            issuer: (item.issuer) ? item.issuer : "",
            expiry: (item.expiry) ? item.expiry : ""
          }
        }
      )
    }

    return tableData;
  }

  const showClusterCertPopUp = (event) => {
    setAnchorElCluster(event.currentTarget);
  }

  const closeClusterPop = (event) => {
    setAnchorElCluster(null);
  }

  return (
    <React.Fragment>
      {error ?
        <Box sx={{ paddingBottom: "10px" }}>
          <Alert severity="error">
            "Error loading data"
          </Alert>
        </Box>
        : null
      }
      {isLoading && <CircularProgress size={24} style={{ marginLeft: 15, position: 'relative', top: 4 }} />}
      <Grid container spacing={3} px={3}>
        <Grid item xs={12} md={12} lg={6}>
          <MDBox sx={{ paddingLeft: "10px" }}>
            <Card sx={{ minWidth: 275, borderRadius: 0 }}>
              <CardContent>
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                  {certData(data).rows[0] !== undefined ? certData(data).rows[0].icon : ""}
                </Typography>
                <Typography variant="h5" component="div" sx={{ color: '#333', fontFamily: 'HelveticaNeue' }}>
                  Cluster Certificate
                </Typography>
                <Typography sx={{ mb: 1.5 }} color="text.secondary">
                  {certData(data).rows[0] !== undefined ? certData(data).rows[0].name : ""}
                </Typography>
                <Typography sx={{ mb: 1.2 }} variant="body2">
                  <b>Issuer:</b> {certData(data).rows[0] !== undefined ? certData(data).rows[0].issuer : ""}
                </Typography>
                <Typography sx={{ mb: 1.2 }} variant="body2">
                  <b>Expiry:</b> {certData(data).rows[0] !== undefined ? certData(data).rows[0].expiry : ""}
                </Typography>
              </CardContent>
              <CardActions>
                <MDBox sx={{ paddingLeft: "10px" }}>
                  <Button
                    size="md"
                    color="primary"
                    onClick={showClusterCertPopUp}>Renew</Button>
                </MDBox>
                <Dialog
                  open={openClusterPop}
                  onClose={closeClusterPop}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">{"Renewal of Cluster Certificates?"}</DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      Renewing Cluster Certificates might cause downtime of applications using kubernetes API.
                      Status App might be unavailable for few minutes. Do you want to Proceeed?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={closeClusterPop} color="primary" style={{ width : '15%'  }}>
                      No
                    </Button>
                    <Button
                      onClick={() => { mutationCluster.mutate(); closeClusterPop(); }}
                      color="primary"
                      autoFocus
                      style={{ width : '15%' }}
                    >
                      Yes
                    </Button>
                  </DialogActions>
                </Dialog>
              </CardActions>
            </Card>
          </MDBox>
        </Grid>
        {certData(data).rows[1] !== undefined ?
          <Grid item xs={12} md={12} lg={6}>
            <MDBox>
              <Card sx={{ minWidth: 275, borderRadius: 0 }}>
                <CardContent>
                  <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                    {certData(data).rows[1] !== undefined ? certData(data).rows[1].icon : ""}
                  </Typography>
                  <Typography variant="h5" component="div" sx={{ color: '#333', fontFamily: 'HelveticaNeue' }}>
                    Ingress Certificate
                  </Typography>
                  <Typography sx={{ mb: 1.5 }} color="text.secondary">
                    {certData(data).rows[1] !== undefined ? certData(data).rows[1].name : ""}
                  </Typography>
                  <Typography sx={{ mb: 1.2 }} variant="body2">
                    <b>Issuer:</b> {certData(data).rows[1] !== undefined ? certData(data).rows[1].issuer : ""}
                  </Typography>
                  <Typography sx={{ mb: 1.2 }} variant="body2">
                    <b>Expiry:</b> {certData(data).rows[1] !== undefined ? certData(data).rows[1].expiry : ""}
                  </Typography>
                </CardContent>        
              </Card>
            </MDBox>
          </Grid>
          : ""
        }
      </Grid>
    </React.Fragment>
  );
}
